package one.healthium.insights.ui.shopping_list.models

import one.healthium.loco.LString

internal data class HeaderUiModel(
    val id: String,
    val text: LString,
    val categories: CategoriesUiModel?,
    val canClear: Boolean = false,
)
